var indexOf = [].indexOf;

angular.module('gym.sequences').factory('SequenceService', ["DefaultReplyAddressService", "$rootScope", "$filter", "flash", function(DefaultReplyAddressService, $rootScope, $filter, flash) {
  return {
    addSequenceStep: function(template, index, collection, sequence) {
      var immediate, ref, step, stepIndex;
      if (template.specified_start_date && moment(template.specified_start_date).isBefore(moment(), 'day')) {
        flash.error = 'Cannot choose membership plan: specified start date is in the past.';
        return;
      }
      immediate = (ref = template.type) === 'task' || ref === 'portal';
      stepIndex = sequence.trigger && index === 0 && collection.length ? this.isForseeable(sequence) ? 1 : 2 : this.isForseeable(sequence) ? index : index + 1;
      step = {
        position: stepIndex + 1,
        branch_node: 1,
        parent_nodes: [1],
        title: this.getStepTitle(template),
        sequence_payloads_attributes: this.getSequencePayload(template),
        sequence_conditions_attributes: [
          {
            type: 'DefaultSequenceCondition'
          }
        ]
      };
      step.sequence_conditions_attributes.push(this.getTimeCondition(stepIndex, sequence, immediate));
      collection.splice(stepIndex, 0, step);
      return this.recalculatePositions(collection, sequence);
    },
    getStepTitle: function(template) {
      var humanizedChannel;
      if (template.type === 'portal') {
        return template.title;
      }
      if (template.type === 'mobile_app') {
        return template.title;
      }
      if (template.type === 'prospect_status') {
        return `Set prospect status to: ${template.status}`;
      }
      if (template.type === 'task') {
        return 'Add task';
      }
      if (template.type === 'workout') {
        return `Add workout to contact: ${template.name}`;
      }
      if (template.template_type === 'membership') {
        return `Add membership: ${template.label}`;
      }
      if (template.type === 'email_user') {
        return "Email user";
      }
      if (template.type === 'style') {
        return `Add style: ${template.name}`;
      }
      if (template.type === 'waiver') {
        return `Send pre-filled waiver: ${template.name}`;
      }
      if (template.type === 'credit_voucher') {
        return `Add a ${template.name} credit voucher`;
      }
      if (template.type === 'makeup_class') {
        return "Add make-up class";
      }
      if (template.type === 'convert_to_nac') {
        return "Convert to Non-Attending Contact";
      }
      if (template.type === 'contact_flag') {
        return "Add flag to contact";
      }
      if (template.type === 'form_field_update') {
        return "Change Custom Field";
      }
      if (template.type === 'note') {
        return "Add note to contact";
      }
      if (template.type === 'access_control') {
        return "Add Brivo Credential to contact";
      }
      humanizedChannel = (function() {
        switch (template.channel) {
          case 'email':
            return "email";
          case 'sms':
            return 'SMS';
          case 'push_notification':
            return 'push notification';
        }
      })();
      if (template.id) {
        return `Send ${humanizedChannel}: ${template.name}`;
      } else {
        return `Send ${humanizedChannel}`;
      }
    },
    getTimeCondition: function(index, sequence, immediate = false) {
      if (index === 0 && this.isForseeable(sequence)) {
        return {
          immediate: immediate,
          trigger: sequence.trigger,
          trigger_time_after: 0,
          trigger_time_before: 0,
          trigger_time_unit: 'days',
          type: 'TriggerSequenceCondition'
        };
      } else {
        return {
          type: 'TimeSequenceCondition',
          immediate: immediate
        };
      }
    },
    recalculatePositions: function(collection, sequence) {
      var timeConditionIndex;
      collection.forEach(function(item, index) {
        var removedItem;
        if (item._destroy) {
          removedItem = collection.splice(index, 1)[0];
          return collection.push(removedItem);
        }
      });
      collection.forEach(function(item, index) {
        return item.position = index + 1;
      });
      if (this.isFloatingFollowable(sequence) && collection[1]) {
        timeConditionIndex = _.findIndex(collection[1].sequence_conditions_attributes, function(condition) {
          return condition.type === 'TimeSequenceCondition';
        });
        if (timeConditionIndex >= 0) {
          collection[1].sequence_conditions_attributes[timeConditionIndex].immediate = false;
          return collection[1].sequence_conditions_attributes[timeConditionIndex].time_since_previous_step_unit = 'days';
        }
      }
    },
    moveStep: function(model, from, to, collection, sequence) {
      collection.splice(from, 1);
      collection.splice(to, 0, model);
      return this.recalculatePositions(collection, sequence);
    },
    presentStepsCount: function(sequence) {
      var steps;
      steps = _.filter(sequence.sequence_steps_attributes, function(step) {
        return !step._destroy;
      });
      return steps.length;
    },
    getSequencePayload: function(template) {
      var gym, params, payloadType, push_notification_image_asset_id, push_notification_image_thumb_url, push_notification_image_url, push_notification_route_name, recipientChoice, ref, replyAddress, sms_opt_out_instructions_policy, subject;
      gym = $rootScope.gym;
      if (template.template_type === 'membership') {
        params = {
          type: 'NewMembershipSequencePayload',
          membership_plan_id: template.id,
          skip_purchase_limit_validation: true
        };
        return [params];
      }
      if (template.type === 'portal') {
        params = {
          type: 'MemberPortalSequencePayload',
          member_portal_enabled: template.enabled
        };
        return [params];
      }
      if (template.type === 'mobile_app') {
        params = {
          type: 'MobileAppSequencePayload',
          mobile_app_enabled: template.enabled,
          send_mobile_app_invite: template.send_mobile_app_invite,
          send_mobile_app_invite_sms: template.send_mobile_app_invite_sms,
          subject: template.subject,
          body: template.body
        };
        return [params];
      }
      if (template.type === 'prospect_status') {
        params = {
          type: 'ProspectStatusChangeSequencePayload',
          prospect_status: template.status
        };
        return [params];
      }
      if (template.type === 'task') {
        params = {
          type: 'TaskSequencePayload',
          task_description: '',
          task_type_id: template.id,
          send_reminder_email: false,
          send_reassign_email: true,
          assigned_to_user_id: $rootScope.gym.users[0].id,
          dueDateEnabled: true
        };
        return [params];
      }
      if (template.type === 'workout') {
        params = {
          type: 'ContactWorkoutSequencePayload',
          workout_id: template.id,
          show_in_member_portal: template.show_in_member_portal,
          show_history_in_member_portal: template.show_history_in_member_portal,
          manageable_by_member: template.manageable_by_member
        };
        return [params];
      }
      if (template.type === 'waiver') {
        params = {
          type: 'SendWaiverSequencePayload',
          waiver_id: template.id
        };
        return [params];
      }
      if (template.type === 'style') {
        params = {
          type: 'NewMemberStyleSequencePayload',
          style_id: template.id,
          rank_id: (ref = template.ranks_attributes[0]) != null ? ref.id : void 0
        };
        return [params];
      }
      if (template.type === 'credit_voucher') {
        params = {
          type: 'AddCreditVoucherSequencePayload',
          credit_voucher_category_id: template.id
        };
        return [params];
      }
      if (template.type === 'makeup_class') {
        params = {
          type: 'AddMakeupClassSequencePayload'
        };
        return [params];
      }
      if (template.type === 'convert_to_nac') {
        params = {
          type: 'ConvertToNacSequencePayload'
        };
        return [params];
      }
      if (template.type === 'contact_flag') {
        params = {
          type: 'AddContactFlagSequencePayload',
          public_flag: gym.gym_config.contact_flag_public_default,
          skip_if_matching_flag_exists: true
        };
        return [params];
      }
      if (template.type === 'form_field_update') {
        params = {
          type: 'FormFieldUpdateSequencePayload',
          form_field_id: template.id
        };
        return [params];
      }
      if (template.type === 'access_control') {
        params = {
          type: 'AddBrivoCredentialSequencePayload'
        };
        return [params];
      }
      if (template.type === 'email_user') {
        params = {
          type: 'EmailUserSequencePayload',
          body: template.id && template.content || '',
          subject: template.subject || '',
          editable: !template.id,
          reply_address: DefaultReplyAddressService.getDefaultEmail(),
          user_id: window.currentUser.id
        };
        return [params];
      }
      if (template.type === 'note') {
        params = {
          type: 'AddNoteSequencePayload',
          skip_if_matching_note_exists: true,
          note_subject: '',
          note_body: ''
        };
        return [params];
      }
      if (template.channel === 'email') {
        payloadType = 'EmailSequencePayload';
        replyAddress = DefaultReplyAddressService.getDefaultEmail();
        subject = template.subject || '';
        recipientChoice = gym.gym_sequence_detail.recipient_choice_default;
      }
      if (template.channel === 'sms') {
        payloadType = 'SmsSequencePayload';
        recipientChoice = gym.gym_sequence_detail.recipient_choice_default;
        sms_opt_out_instructions_policy = template.sms_opt_out_instructions_policy || gym.presented_gym_sms_detail.sms_opt_out_instructions_policy;
      }
      if (template.channel === 'push_notification') {
        payloadType = 'PushNotificationSequencePayload';
        subject = template.subject || '';
        push_notification_route_name = template.push_notification_route_name;
        push_notification_image_url = template.push_notification_image_url;
        push_notification_image_asset_id = template.push_notification_image_asset_id;
        push_notification_image_thumb_url = template.push_notification_image_thumb_url;
      }
      return [
        {
          body: template.id && template.content || '',
          communication_template_id: template.id,
          editable: !template.id,
          name: template.id && template.name || '',
          reply_address: replyAddress,
          subject: subject,
          type: payloadType,
          recipient_choice: recipientChoice,
          sms_opt_out_instructions_policy: sms_opt_out_instructions_policy,
          push_notification_route_name: push_notification_route_name,
          push_notification_image_url: push_notification_image_url,
          push_notification_image_asset_id: template.push_notification_image_asset_id,
          push_notification_image_thumb_url: push_notification_image_thumb_url
        }
      ];
    },
    formatTemplateType: function(type) {
      switch (type.toLowerCase()) {
        case 'email':
          return 'Email';
        case 'sms':
          return 'SMS';
        case 'push_notification':
          return 'Push Notification';
      }
    },
    onTriggerChanged: function(sequence) {
      var firstStep, ref;
      firstStep = sequence.sequence_steps_attributes[0];
      if (this.isForseeable(sequence)) {
        if (this.isTriggerConditionExists(firstStep)) {
          sequence.sequence_steps_attributes.splice(0, 1);
        }
        if (sequence.sequence_steps_attributes.length) {
          this.removeTimeCondition(sequence.sequence_steps_attributes[0]);
          this.addTriggerCondition(sequence.sequence_steps_attributes[0], sequence);
        }
      } else {
        if (this.isTriggerConditionExists(firstStep)) {
          if ((ref = firstStep.sequence_conditions_attributes) != null ? ref[0] : void 0) {
            firstStep.sequence_conditions_attributes[0].trigger = sequence.trigger;
          }
          if (this.isPayloadPresent(firstStep)) {
            this.removeTriggerCondition(firstStep);
            this.addTimeCondition(firstStep);
            this.addTriggerStep(sequence);
          }
        } else {
          this.addTriggerStep(sequence);
        }
      }
      return this.recalculatePositions(sequence.sequence_steps_attributes, sequence);
    },
    isPayloadPresent: function(step) {
      return !!(step != null ? step.sequence_payloads_attributes.length : void 0);
    },
    getTriggerStep: function(sequence) {
      var isImmediate;
      isImmediate = !this.isForseeable(sequence);
      return {
        position: 1,
        branch_node: 1,
        parent_nodes: [1],
        sequence_payloads_attributes: [],
        sequence_conditions_attributes: [
          {
            immediate: isImmediate,
            trigger: sequence.trigger,
            trigger_time_after: 0,
            trigger_time_before: 0,
            trigger_time_unit: 'days',
            type: 'TriggerSequenceCondition'
          },
          {
            type: 'DefaultSequenceCondition'
          }
        ]
      };
    },
    addTriggerCondition: function(step, sequence) {
      var isImmediate;
      isImmediate = !this.isForseeable(sequence);
      return step.sequence_conditions_attributes.push({
        immediate: isImmediate,
        trigger: sequence.trigger,
        trigger_time_after: 0,
        trigger_time_before: 0,
        trigger_time_unit: 'days',
        type: 'TriggerSequenceCondition'
      });
    },
    removeTriggerCondition: function(step) {
      var conditionIndex;
      conditionIndex = _.findIndex(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'TriggerSequenceCondition';
      });
      return step.sequence_conditions_attributes.splice(conditionIndex, 1);
    },
    addTimeCondition: function(step) {
      return step.sequence_conditions_attributes.push({
        type: 'TimeSequenceCondition'
      });
    },
    addReportCondition: function(step, filter, type) {
      return step.sequence_conditions_attributes.push({
        report_attributes: {
          report_filters_attributes: [filter]
        },
        type: type
      });
    },
    addReportFilter: function(step, filter, type) {
      var conditionIndex, sequenceCondition;
      conditionIndex = _.findIndex(step.sequence_conditions_attributes, function(condition) {
        return condition.type === type;
      });
      if (conditionIndex >= 0) {
        sequenceCondition = step.sequence_conditions_attributes[conditionIndex];
        sequenceCondition.report_attributes.report_filters_attributes.push(filter);
        return sequenceCondition._destroy = void 0;
      } else {
        return this.addReportCondition(step, filter, type);
      }
    },
    removeTimeCondition: function(step) {
      var conditionIndex;
      conditionIndex = _.findIndex(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'TimeSequenceCondition';
      });
      return step.sequence_conditions_attributes.splice(conditionIndex, 1);
    },
    removeEnrolmentLimitSequenceCondition: function(step) {
      var conditionIndex;
      conditionIndex = _.findIndex(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'EnrolmentLimitSequenceCondition';
      });
      if (step.sequence_conditions_attributes[conditionIndex].id) {
        return step.sequence_conditions_attributes[conditionIndex]._destroy = 1;
      } else {
        return step.sequence_conditions_attributes.splice(conditionIndex, 1);
      }
    },
    removeReportCondition: function(step, type) {
      var conditionIndex;
      conditionIndex = _.findIndex(step.sequence_conditions_attributes, function(condition) {
        return condition.type === type;
      });
      return step.sequence_conditions_attributes.splice(conditionIndex, 1);
    },
    addTriggerStep: function(sequence) {
      var triggerStep;
      triggerStep = this.getTriggerStep(sequence);
      sequence.sequence_steps_attributes.splice(0, 0, triggerStep);
      return this.recalculatePositions(sequence.sequence_steps_attributes, sequence);
    },
    isTriggerConditionExists: function(step) {
      if (!step) {
        return;
      }
      return _.findWhere(step.sequence_conditions_attributes, {
        type: 'TriggerSequenceCondition'
      });
    },
    isTimeConditionExists: function(step) {
      if (!step) {
        return;
      }
      return _.findWhere(step.sequence_conditions_attributes, {
        type: 'TimeSequenceCondition'
      });
    },
    isConditionTypeExists: function(step, type) {
      if (!step) {
        return;
      }
      return _.find(step.sequence_conditions_attributes, function(condition) {
        return condition.type === type;
      });
    },
    isReportConditionExists: function(step) {
      if (!step) {
        return;
      }
      return _.find(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'ReportSequenceCondition';
      });
    },
    isScopedReportConditionExists: function(step) {
      if (!step) {
        return;
      }
      return _.find(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'ScopedReportSequenceCondition';
      });
    },
    hasReportSkipSequenceCondition: function(step) {
      if (!step) {
        return;
      }
      return _.find(step.sequence_conditions_attributes, function(condition) {
        var ref;
        return (ref = condition.type) === 'ReportSkipSequenceCondition' || ref === 'ScopedReportSkipSequenceCondition';
      });
    },
    isEnrolmentLimitSequenceConditionExists: function(step) {
      if (!step) {
        return;
      }
      return _.find(step.sequence_conditions_attributes, function(condition) {
        return condition.type === 'EnrolmentLimitSequenceCondition' && !condition._destroy;
      });
    },
    apparentPosition: function(step, sequence) {
      if (this.isForseeable(sequence)) {
        return step.position;
      } else {
        return step.position - 1;
      }
    },
    isForseeable: function(sequence) {
      var ref;
      return ref = sequence.trigger, indexOf.call(sequence.forseeable_triggers, ref) >= 0;
    },
    isFollowable: function(sequence) {
      var ref;
      return ref = sequence.trigger, indexOf.call(sequence.followable_triggers, ref) >= 0;
    },
    isFloatingFollowable: function(sequence) {
      var ref;
      if (!sequence) {
        return;
      }
      return ref = sequence.trigger, indexOf.call(sequence.floating_followable_triggers, ref) >= 0;
    },
    getTemplatesByType: function(templates, type) {
      var templatesByType;
      templatesByType = _.filter(templates, function(template) {
        return template.channel === type;
      });
      templatesByType.unshift({
        name: 'Blank Template',
        channel: type,
        content: `Create a new ${this.formatTemplateType(type)} from scratch.`
      });
      return templatesByType;
    },
    sanitizePayloadAttributes: function(sequence) {
      return sequence.sequence_steps_attributes.forEach(function(step) {
        return step.sequence_payloads_attributes.forEach(function(payload) {
          switch (payload.type) {
            case 'EmailSequencePayload':
            case 'EmailUserSequencePayload':
              payload.subject = $filter('sanitizeEditorField')(payload.subject, true, {
                target: 'subject'
              });
              return payload.body = $filter('domPurify')(payload.body);
            case 'SmsSequencePayload':
              return payload.body = $filter('sanitizeEditorField')(payload.body, true);
            case 'PushNotificationSequencePayload':
              payload.subject = $filter('sanitizeEditorField')(payload.subject, true, {
                target: 'subject'
              });
              return payload.body = $filter('sanitizeEditorField')(payload.body, true);
            case 'MobileAppSequencePayload':
              if (payload.subject) {
                payload.subject = $filter('sanitizeEditorField')(payload.subject, true, {
                  target: 'subject'
                });
              }
              if (payload.body) {
                if (payload.send_mobile_app_invite) {
                  return payload.body = $filter('domPurify')(payload.body);
                } else {
                  return payload.body = $filter('sanitizeEditorField')(payload.body, true);
                }
              }
          }
        });
      });
    },
    getTriggers: function(sequence) {
      return _.chain(sequence.followable_triggers).union(sequence.floating_followable_triggers).union(sequence.forseeable_triggers).uniq().sortBy(function(item) {
        return sequence.humanized_trigger_names[item];
      }).value();
    }
  };
}]);
